<mat-toolbar class="p-0 mat-elevation-z1">
    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && !rightNavbar"
                (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>
            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>
            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/fuse.svg">
                </div>
            </div>

            <div class="px-8 px-md-16">
                <h5>{{idleState}}</h5>
                <!-- <p *ngIf="lastPing"><small>Last keepalive ping <strong>{{lastPing | amTimeAgo}}</strong></small></p> -->
            </div>
            <!-- <div class="px-8 px-md-16"> 
                <button (click)="reset()" *ngIf="timedOut">Restart</button>
            </div> -->
        </div>



        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">


            &nbsp;&nbsp;
            <div class="toolbar-separator"></div>

            <form [formGroup]="busquedaForm">
                <button mat-button class="user-button" [matMenuTriggerFor]="userMenu3">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <!-- <img class="comercioLogo mr-0 mr-sm-16" src="{{imgLogo}}"> -->
                        <span class="username mr-12" fxHide fxShow.gt-sm> {{nombreGrupo}} </span>
                        <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                    </div>
                </button>
                <mat-menu #userMenu3="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item *ngFor="let cboGroup of cboGrupos" [value]="cboGroup.grupoName"
                        (click)="cambioGrupo(cboGroup.comercios,cboGroup.grupoName)">
                        <span> {{ cboGroup.grupoName }}</span>
                    </button>
                </mat-menu>
            </form>


            <div class="toolbar-separator"></div>

            <form [formGroup]="busquedaComercioForm">
                <button mat-button [matMenuTriggerFor]="userMenu2" class="user-button">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <img class="mr-0 mr-sm-16" src="assets/icons/flags/{{imgFlag}}.png">
                        <span class="username mr-12" fxHide fxShow.gt-sm> {{paisId}} </span>
                        <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                    </div>
                </button>
                <mat-menu #userMenu2="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item *ngFor="let cboCom of cboComercio" [value]="cboCom.comercioid"
                        (click)="cambioComercio(cboCom.nombre,cboCom.comercioid,cboCom.paisId,cboCom.monedas,cboCom.customLoad,cboCom.flagUniqueWallet,cboCom.flagSendH2h)">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <img class="mr-0 mr-sm-16" src="assets/icons/flags/{{cboCom.paisId}}.png">
                            <span> {{ cboCom.paisId }}</span>
                        </div>

                    </button>
                </mat-menu>
            </form>

            <div class="toolbar-separator"></div>

            <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="avatar mr-0 mr-sm-16" src="assets/images/avatars/user.png">
                    <span class="username mr-12" fxHide fxShow.gt-sm>{{nombreUsuario}} ({{rolUsuario}})</span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item (click)="btnProfile()">
                    <mat-icon>account_circle</mat-icon>
                    <span>{{'ELEM_GENERIC.PERFIL' | translate}}</span>
                </button>
                <button mat-menu-item (click)="btnMfa()">
                    <mat-icon>vpn_key</mat-icon>
                    <span>{{'MFA.MFA_TWO_STEP_LABEL' | translate}}</span>
                </button>
                <button mat-menu-item class="" (click)="logoutUser()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>

            <div class="toolbar-separator"></div>

            <!-- <button mat-button fxHide fxShow.gt-xs class="language-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="flag mr-8" [src]="'assets/icons/flags/pe.png'">
                    <span class="iso text-uppercase">PE</span>
                </div>
            </button> -->

            <!-- <div class="toolbar-separator"></div> -->

        </div>
    </div>
</mat-toolbar>